enum AccentColor {
  GREY = "#D1D3D6",
  PURPLE = "#613DE5",
  PINK = "#E43DC9",
  GREEN = "#1DA854",
  ORANGE = "#F7700B",
  BLUE = "#1990E8",
}

export default AccentColor;
